import React from 'react'
import styled from 'styled-components'
import { theme } from '../theme'
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock'
import { IconLarge } from '.'
import { translate } from '../util/translate'

const Title = styled.h3`
  position: relative;
  display: inline-block;
  margin-right: 32px;
  font-family: 'Roboto', sans-serif, arial;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-transform: uppercase;
  color: #303030;
  transition: color 0.2s;
  margin-bottom: 6px;

  &:after {
    position: absolute;
    content: '';
    display: block;
    top: calc(50% - 8px);
    left: 100%;
    background: transparent url('/img/arrow_right_blue_big.png') no-repeat right top;
    background-size: auto 14px;
    width: 0;
    height: 14px;
    transition: width 0.3s;
  }
`

const ArticleAnchor = styled.a`
  position: relative;
  z-index: 1;
  display: block;
  font-family: 'Roboto', sans-serif, arial;
  padding: 16px;
  background-color: #f5f5f5;
  text-decoration: none;

  @media (max-width: ${theme.breakpoints.mobile}px) {
    padding: 12px;
  }

  margin-bottom: 8px;

  &:hover ${Title} {
    color: #56a0d3;
    text-decoration: underline;

    &:after {
      width: 32px;
    }
  }
`

const Content = styled.div`
  position: relative;
`

const DateContent = styled.span`
  display: block;
  font-size: 12px;
  line-height: 19px;
  color: #303030;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`

const Text = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #303030;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`

const AdditionalInfo = styled.div`
  display: flex;
  align-items: end;

  svg {
    color: #939393;
    margin-right: 8px;
  }

  span {
    color: #939393;
    font-size: 12px;
  }
`

type ArticleProps = {
  title: string
  date: string
  intro: string | null
  link: string
  loginRequired: boolean
  additionalInfo: string
}
export const Article: React.FC<ArticleProps> = ({ title, date, intro, link, loginRequired, additionalInfo }) => (
  <ArticleAnchor href={link}>
    <Content>
      <Title>{title}</Title>
      {date.length > 0 && (
        <DateContent>
          {translate('Last updated')}: {date}
        </DateContent>
      )}
      {intro != null && intro?.length > 0 && <Text>{intro}</Text>}

      {(loginRequired === true || (additionalInfo != null && additionalInfo.length > 0)) && (
        <AdditionalInfo>
          {loginRequired === true && <IconLarge icon={faLock} />}
          <span>{additionalInfo}</span>
        </AdditionalInfo>
      )}
    </Content>
  </ArticleAnchor>
)
